$(document).on('turbolinks:load', function() {
    $('#contactFormSubmit').on('click', function() {
        $(this).prop('disabled', true);
        $(this).html('Submitting  <i class="fas fa-spinner fa-pulse"></i>');
    });
});
